import {format} from 'date-fns';
import { ColumnFilter } from './ColumnFilter';

export const COLUMNS = [
	{
		id: 'id',
		header: 'Id',
		accessorKey: 'id',
		Filter: ColumnFilter,
		//disableFilters: true,
	},
	{
		id: 'first_name',
		header: 'First Name',
		accessorKey: 'first_name',
		Filter: ColumnFilter,
	},
	{
		id: 'last_name',
		header: 'Last Name',
		accessorKey: 'last_name',
		Filter: ColumnFilter,
	},
	{
		id: 'email',
		header: 'Email Id',
		accessorKey: 'email',
		Filter: ColumnFilter,
	},
	{
		id: 'date_of_birth',
		header: 'Date of Birth',
		accessorKey: 'date_of_birth',
		cell: ({ getValue }) => {
			const value = getValue();
			return format(new Date(value), 'dd/MM/yyyy');
		},
		Filter: ColumnFilter,
	},
	{
		id: 'country',
		header: 'Country',
		accessorKey: 'country',
		Filter: ColumnFilter,
	},
	{
		id: 'phone',
		header: 'Phone',
		accessorKey: 'phone',
		Filter: ColumnFilter,
	},
]

export const GROUPED_COLUMNS = [
	{
		Header : 'Id',
		Footer : 'Id',
		accessor: 'id'
	},
	{
		Header : 'Name',
		Footer : 'Name',
		columns: [
			{
				Header : 'First Name',
				Footer : 'First Name',
				accessor: 'first_name'
			},
			{
				Header : 'Last Name',
				Footer : 'Last Name',
				accessor: 'last_name'
			},
		]
	},
	{
		Header: 'Info',
		Footer: 'Info',
		columns: [
			{
				Header : 'Date of  Birth',
				Footer : 'Date of  Birth',
				accessor: 'date_of_birth'
			},
			{
				Header : 'Country',
				Footer : 'Country',
				accessor: 'country',
			},
			{
				Header : 'Phone',
				Footer : 'Phone',
				accessor: 'phone'
			},
		]
	},
]